import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Link from './common/TrackedLink';
import ButtonLink from './common/TrackedButtonLink';
import ProductImageCTA from './common/ProductImageCTA';
import LazyLoad from 'react-lazyload';

class Home extends Component {
	render() {
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.products != null) {
			const productImageCta = this.props.products.map((product,index) => (
				<ProductImageCTA
					key={ index }
					imgSrc={ product.image }
					title={ product.description }
					listPrice={ product.priceBucket }
					modelNumber={ product.modelNumber }
				/>
			));
			topProducts = (
				<section className="row safes-callout">
					<div className="col sm-3 callout-descr">
						<h2 className="section-title">Best&#45;Selling Products</h2>
						<p>The most versatile protection SentrySafe has to offer.</p>
						<ButtonLink className="btn-primary" to="/products?bestOfBest=true">
							View All Best-Selling Products
						</ButtonLink>
					</div>
					<div className="col sm-9 products">
						<ul>
							{ productImageCta }
						</ul>
					</div>
				</section>
			);
		}

		return (
			<div className="container home">
				<Helmet
					htmlAttributes={{
						itemscope: undefined,
						itemtype: 'https://schema.org/WebSite',
					}}
					link={[{
						rel: 'canonical',
						href: 'https://www.sentrysafe.com/'
					}]}
				>
					<title>Firearm Storage at a New, Lower Price | SentrySafe</title>
					<meta name="description" content="SentrySafe offers a broad range of secure storage solutions to keep your valuables protected from unexpected perils, theft and more. View safes." />
				</Helmet>

				<header className="home-hero">
					<img
						className="hero-image"
						src={ require('../resources/img/hero/homepage.jpg') }
						alt="Quick access biometric pistol safe model: qap1blx."

					/>
					<div className="hero-content dark">
						<div className="row">
							<div className="col uppercase">
								<h1 className="title">
									$20 OFF
								</h1>
								<p>Quick-access biometric pistol safe</p>
								<ButtonLink
									to="https://store.sentrysafe.com/pistol-safes/quick-access-biometric-pistol-safe-qap1blx.html"
									className="btn-primary"
									target="_self"
									rel="noopener"
								>
									Buy Now
								</ButtonLink>
							</div>
						</div>
					</div>
				</header>

				{ topProducts }

				<Link className="product-feature" to="/safe-selector">
					<div className="feature-image">
						<img src={ require('../resources/img/safe-selector-feature.png') } alt="" />
					</div>
					<div className="feature-content">
						<h2 className="feature-title feature-title--large">
							Not sure what<br /> you&rsquo;re looking for?
						</h2>
						<p>We&rsquo;ll help you find the right safe for your needs.</p>
						<div>
							<span className="btn btn-primary">Find your safe</span>
						</div>
					</div>
				</Link>

				<section className="row feature-callout callout-alt">
					<div className="col sm-5 sm-hide">
						<LazyLoad once={ true } offset={ 200 }>
							<img
								src={ require('../resources/img/callouts/flood.jpg') }
								alt="Man observing his flooded home"
							/>
						</LazyLoad>
					</div>
					<div className="col sm-7 content">
						<div>
							<img
								className="icon"
								src={ require('../resources/img/icons/fire-icon.png') }
								srcSet={ `${require('../resources/img/icons/fire-icon@2x.png')} 2x` }
								alt="Fire Resistant"
							/>
							<img
								className="icon"
								src={ require('../resources/img/icons/water-icon.png') }
								srcSet={ `${require('../resources/img/icons/water-icon@2x.png')} 2x` }
								alt="Water Resistant"
							/>
							<h3>Water &amp; Fire Protection</h3>
							<p>Safeguard your belongings from the most unexpected perils.</p>
							<ButtonLink className="btn-primary" to="/fire-waterproof-safes">
								Learn about water &amp; fire safes
							</ButtonLink>
						</div>
					</div>
				</section>

				<section className="card-container my-5">
					<div className="card">
						<a href="/learn/buying-guide">
							<div>
								<img
									src={ require('../resources/img/callouts/promo-left.jpg') }
									alt="Locked safe"
								/>
							</div>
							<div className="card-body">
								<h2>Which Safe Is Right For You?</h2>
								<p>We’ll help you find the best safe to fit your needs, so you can start protecting what’s most valuable to you.</p>
								<div className="pt-4">
									<span className="btn btn-primary">Learn More</span>
								</div>
							</div>
						</a>
					</div>
					<div className="card col-md-10 col-lg-4">
						<a href="/support/lost-key-combo">
							<div>
								<img
									src={ require('../resources/img/callouts/promo-center.jpg') }
									alt="Safe with a key in the lock"
								/>
							</div>
							<div className="card-body">
								<h2>Lost Your Key or Combination?</h2>
								<p>With our easy key &amp; combo replacement process, you can quickly request a new combination or replacement key.</p>
								<div className="pt-4">
									<span className="btn btn-primary">Get Started</span>
								</div>
							</div>
						</a>
					</div>
					<div className="card col-md-10 col-lg-4">
						<a href="https://www.masterlock.com/" target="_blank">
							<div>
								<img
									src={ require('../resources/img/callouts/promo-right-100yrBlueYears.png') }
									alt="Lock on a fence"
								/>
							</div>
							<div className="card-body">
								<h2>Master Lock</h2>
								<p>For 100 years our products have provided peace of mind and protection to people, businesses and communities across the globe.</p>
								<div className="pt-4">
									<span className="btn btn-primary"><span className="fa fa-external-link"></span> Visit MasterLock.com</span>
								</div>
							</div>
						</a>
					</div>
				</section>

			</div>
		);
	}
}

export default branch({
	products: ['product', 'featuredProduct', 'products'],
}, Home);




// WEBPACK FOOTER //
// ./src/pages/Home.js